import React from 'react'
import './styles.scss'

const Block6 = (props) => {
  return (
    <p className='block6'>S3 Video</p>
  )
}

export default Block6
